import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore';
import { db, auth } from './firebase'; // Ensure this path matches your setup
import './cart.css';

function Cart() {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchCartItems = async () => {
      const currentUser = auth.currentUser;

      if (currentUser) {
        const userId = currentUser.uid;

        try {
          // Reference the Cart subcollection
          const cartCollectionRef = collection(db, `users/${userId}/Cart`);
          const querySnapshot = await getDocs(cartCollectionRef);

          const items = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));

          setCartItems(items);
        } catch (error) {
          console.error('Error fetching cart items:', error);
          setError('Failed to fetch cart items.');
        } finally {
          setLoading(false);
        }
      } else {
        console.log('User not logged in.');
        setLoading(false);
      }
    };

    fetchCartItems();
  }, []);

  const handleRemoveItem = async (itemId) => {
    const currentUser = auth.currentUser;

    if (currentUser) {
      const userId = currentUser.uid;
      try {
        // Reference the specific cart item document
        const cartItemDocRef = doc(db, `users/${userId}/Cart`, itemId);
        await deleteDoc(cartItemDocRef);

        // Update state to remove the item from the UI
        setCartItems((prevItems) => prevItems.filter(item => item.id !== itemId));
      } catch (error) {
        console.error('Error removing cart item:', error);
        setError('Failed to remove cart item.');
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="cart-items-list">
      {cartItems.length > 0 ? (
        cartItems.map(item => (
          <div key={item.id} className="cart-item">
            <img src={item.imageUrl} alt={item.name} className="cart-item-image" />
            <div className="cart-item-info">
              <h4>{item.name}</h4>
              <p>Model: {item.model}</p>
              <p>Price: ₹{item.price}</p>
              <p>Quantity: {item.quantity}</p>
              <button onClick={() => handleRemoveItem(item.id)} className="remove-button">Remove From Cart</button>
            </div>
          </div>
        ))
      ) : (
        <p>Your cart is empty.</p>
      )}
    </div>
  );
}

export default Cart;
